module.exports = __webpack_public_path__ + "img/score3.41a50f33.png";